var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('activity-stage', {
    attrs: {
      "customRootContainerClass": ("" + (_vm.isMobile ? '' : 'full-height')),
      "customContentContainerStyles": {
        height: 'calc(100% - 55px)'
      }
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('activity-wrapper', {
    attrs: {
      "slot": "content",
      "allowScroll": true
    },
    slot: "content"
  }, [_vm.currentRound.optionalContent ? _c('section', {
    staticClass: "dynamicContentSection"
  }, [_c('dynamic-content', {
    attrs: {
      "dynamicContent": _vm.currentRound.optionalContent
    }
  })], 1) : _vm._e(), _c('section', {
    staticClass: "question-section"
  }, [_c('div', {
    staticClass: "question"
  }, [_c('html-renderer', {
    attrs: {
      "htmlObject": _vm.currentRound && _vm.currentRound.questionHtml
    }
  })], 1)]), _c('div', {
    staticClass: "answers-container"
  }, [_vm.equationSymbols ? _c('div', {
    staticClass: "answers"
  }, [_c('article', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "column",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "equation"
  }, [_vm._l(_vm.equationSymbols, function (symbol) {
    return [symbol.fraction ? _c('div', {
      staticClass: "fraction-container"
    }, [_c('div', {
      staticClass: "fraction-row"
    }, [_vm._l(symbol.fraction.numerator, function (fractionedSymbol, index) {
      return [fractionedSymbol.isAnswer ? [_c('answer-input', {
        ref: "answerInputs",
        refInFor: true,
        staticClass: "number-input",
        attrs: {
          "ariaLabel": ("Textbox for numerator input " + (index + 1) + " of " + (symbol.fraction.numerator.length) + (_vm.answers[fractionedSymbol.index] && _vm.answers[fractionedSymbol.index] !== ' ' ? (", current value - " + (_vm.answers[fractionedSymbol.index])) : '')),
          "answer": _vm.showAnswers && !_vm.answers[fractionedSymbol.index] && !_vm.disabled[fractionedSymbol.index] ? fractionedSymbol.characters.toString() : '',
          "maxLength": 3,
          "error": _vm.errors[fractionedSymbol.index],
          "disabled": _vm.disabled[fractionedSymbol.index],
          "inputOverride": _vm.numPadAnswerInputOverrides[fractionedSymbol.index]
        },
        on: {
          "focus": function ($event) {
            _vm.focusedAnswerInputSymbolIndex = fractionedSymbol.index;
          },
          "input": function (e) {
            return _vm.handleOnAnswerInput(e, fractionedSymbol.index);
          }
        }
      })] : [_c('span', {
        staticClass: "inline-operators"
      }, [_vm._v(_vm._s(fractionedSymbol.characters))])]];
    })], 2), _c('hr', {
      staticStyle: {
        "width": "100%"
      }
    }), _c('div', {
      staticClass: "fraction-row"
    }, [_vm._l(symbol.fraction.denominator, function (fractionedSymbol) {
      return [fractionedSymbol.isAnswer ? [_c('answer-input', {
        ref: "answerInputs",
        refInFor: true,
        staticClass: "number-input",
        attrs: {
          "ariaLabel": ("Textbox for denominator input " + (_vm.index + 1) + " of " + (symbol.fraction.denominator.length) + (_vm.answers[fractionedSymbol.index] && _vm.answers[fractionedSymbol.index] !== ' ' ? (", current value - " + (_vm.answers[fractionedSymbol.index])) : '')),
          "answer": _vm.showAnswers && !_vm.answers[fractionedSymbol.index] && !_vm.disabled[fractionedSymbol.index] ? fractionedSymbol.characters.toString() : '',
          "maxLength": 3,
          "error": _vm.errors[fractionedSymbol.index],
          "disabled": _vm.disabled[fractionedSymbol.index],
          "inputOverride": _vm.numPadAnswerInputOverrides[fractionedSymbol.index]
        },
        on: {
          "focus": function ($event) {
            _vm.focusedAnswerInputSymbolIndex = fractionedSymbol.index;
          },
          "input": function (e) {
            return _vm.handleOnAnswerInput(e, fractionedSymbol.index);
          }
        }
      })] : [_c('span', {
        staticClass: "inline-operators"
      }, [_vm._v(_vm._s(fractionedSymbol.characters))])]];
    })], 2)]) : [symbol.isAnswer ? [_c('answer-input', {
      ref: "answerInputs",
      refInFor: true,
      staticClass: "number-input",
      attrs: {
        "ariaLabel": ("Textbox for answer input " + (_vm.indexOfEquationAnswer(symbol.index) + 1) + (_vm.answers[symbol.index] && _vm.answers[symbol.index] !== ' ' ? (", current value - " + (_vm.answers[symbol.index])) : '')),
        "answer": _vm.showAnswers && !_vm.answers[symbol.index] && !_vm.disabled[symbol.index] ? symbol.characters.toString() : '',
        "maxLength": 3,
        "error": _vm.errors[symbol.index],
        "disabled": _vm.disabled[symbol.index],
        "inputOverride": _vm.numPadAnswerInputOverrides[symbol.index]
      },
      on: {
        "focus": function ($event) {
          _vm.focusedAnswerInputSymbolIndex = symbol.index;
        },
        "input": function (e) {
          return _vm.handleOnAnswerInput(e, symbol.index);
        }
      }
    })] : [_c('span', {
      staticClass: "inline-operators"
    }, [_vm._v(_vm._s(symbol.characters))])]]];
  })], 2), _c('article', {
    style: {
      margin: '16px 0px 0px 0px',
      minHeight: '64px'
    },
    attrs: {
      "aria-live": "assertive",
      "role": "region"
    }
  }, [_vm.isComplete ? _c('success-check-solid-icon', {
    attrs: {
      "height": "26",
      "width": "37"
    }
  }) : _vm._e(), _vm.showErrors && !_vm.isComplete ? _c('article', {
    staticStyle: {
      "display": "flex",
      "gap": "10px"
    }
  }, [_c('red-x-solid-icon', {
    attrs: {
      "height": "26",
      "width": "27"
    }
  }), _c('h5', {
    staticStyle: {
      "color": "#FF0000",
      "margin": "0px"
    }
  }, [_vm._v("\n                " + _vm._s(_vm.numberOfInputErrors) + " of the input boxes contain an error\n              ")])], 1) : _vm._e()], 1)])]) : _vm._e(), _c('div', {
    staticClass: "keyboard-positioning-wrapper"
  }, [_c('number-pad-keyboard')], 1)])])], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }